const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-drawer', class extends Core { 
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleAddingToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
    }

    _handleAddingToCart({ req }) {
        if(req === 'cartAdd') {
            // Show success message
let successMessage = document.createElement("div");
successMessage.innerHTML = "✅ Item added to cart!";
successMessage.style.position = "fixed";
successMessage.style.bottom = "20px";
successMessage.style.right = "20px";
successMessage.style.backgroundColor = "#4CAF50";
successMessage.style.color = "white";
successMessage.style.padding = "10px 15px";
successMessage.style.borderRadius = "5px";
successMessage.style.zIndex = "1000";
document.body.appendChild(successMessage);

// Remove message after 3 seconds
setTimeout(() => {
    successMessage.remove();
}, 3000);
        }
    }

    _handleCartChange({ key }) {
        this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
        if(!this.updatingProduct) {
            return;
        }

        $loading(this.updatingProduct);
    }

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        this.updatingProduct && $loading(this.updatingProduct, false);
    }
})